export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14351.40150302.jpg";